import React , {Component} from 'react';
import * as axios from "axios/index";
import SlideCard from './../Cards/SlideCard';
import BranchCard from './../Cards/BranchCard';
import HomeLoader from './../Loader/HomeLoader';
import * as vars from './Vars';
import {
    Page,Swiper,SwiperSlide , List , ListItem , Popover , Button , Link
} from 'framework7-react';
import {
    toolbar
} from "../actions";
import {connect} from "react-redux";




class BranchList extends Component{
    constructor() {
        super();


        this.state = {
            requestLoading : true ,
            branches : [] ,
            slides : [] ,
            categoryFilter : "همه رستوران ها" ,
            allCategories : [] ,
        }
    }

    catChange(event){
        this.setState({
            categoryFilter : event.srcElement.innerText
        })
    }

    componentDidMount() {

        if (localStorage.getItem('city') === undefined || localStorage.getItem('city') === null )
        {
            this.$f7router.navigate('/city/')
            return false
        }



        let data = new FormData()
        data.append('user_app_version' , '100' )
        data.append('a_token' , 'webapp' )
        data.append('test_mode' , '0' )
        data.append('city_id' , localStorage.getItem('city') )
        data.append('mobile' , localStorage.getItem('mobile') )
        data.append('imei_code' , localStorage.getItem('imeiCode') )
        data.append('users_ID' , localStorage.getItem('users_ID') )

        axios.post( vars.PreUrl + 'https://www.lavefood.com/v2/branchs' ,
            data )
            .then(response => {
                let data = response.data.result[0]

                // console.log(data)
                if(data.error === 0)
                {
                    localStorage.setItem('usersCredit' , data.users_credit)
                    this.setState({
                        requestLoading : false ,
                        slides : data.baners ,
                        branches : data.branchs ,
                        allCategories : data.allCategories
                    })
                }
                else
                {

                }


            })
            .catch(error => {
                console.log(error)
            })
    }

    onPageBeforeIn(){
        this.props.toolbar(true)
    }


    render(){



        let branches = [...this.state.branches];
        branches.sort((a,b) => b.rate - a.rate);

        return(
            <Page name="BranchList" className="position-relative" onPageBeforeIn={this.onPageBeforeIn.bind(this)} noToolbar={true}>
                {
                    this.state.requestLoading === true ? (
                        <HomeLoader  />
                    ) : (
                        <div id="inner-content">
                            <Swiper  params={{speed:500, slidesPerView: 1, spaceBetween: 0 , autoplay:{delay:1500}}} id="top-slider">
                                {this.state.slides.map((object , index) =>
                                    <SwiperSlide  key={index} >
                                        <SlideCard object={object}/>
                                    </SwiperSlide>
                                )}
                            </Swiper>

                            <div className="b-row no-gutters ">
                                <div className="b-col-12">
                                    <div id="branch-filter">

                                        <div id="branch-categories-container">
                                            <Link id="branch-categories" popoverOpen="#category-select-popup">
                                                <img className="icon" src="https://www.lavefood.com/webappassets/images/toolbar-resturan-tab-off.svg"/>
                                                <span>{this.state.categoryFilter}</span>
                                            </Link>
                                        </div>

                                    </div>
                                </div>
                               {/* <div className="b-col-1">

                                    <Link href="/city/" id="city-change">
                                        <i className="fas fa-map-marker-alt"></i>
                                    </Link>
                                </div>*/}
                            </div>



                            <div id="branches-container">

                                {branches.map((object , index) =>
                                    <BranchCard object={object} key={index} category={this.state.categoryFilter} />
                                )}
                            </div>

                        </div>
                    )
                }
                <Popover className="popover-menu" id="category-select-popup">
                    <List >
                        {this.state.allCategories.map((object , index) =>
                            <ListItem onClick={this.catChange.bind(this)} link="#" popoverClose title={object} key={index}  />
                        )}

                    </List>
                </Popover>
            </Page>
        )
    }
}




const mapDispatchToProps = dispatch => ({


    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(BranchList);